<template>
  <div>
    <b-sidebar v-model="sidebarOpened" shadow z-index="99999999" width="100%" @hidden="onHide" @shown="onShown">
      <slot name="content"></slot>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "FullscreenSidebar",
  data: function () {
    return {
      sidebarOpened: false,
    };
  },
  methods: {
    open() {
      this.sidebarOpened = true;
    },
    close() {
      this.sidebarOpened = false;
    },
    onHide() {
      this.$emit("onHide");
    },
    onShown() {
      this.$emit("onShown");
    },
  },
};
</script>

